import React from "react";
import { MapPin, Calendar, Users } from "lucide-react";
import useAuthStore from "@/stores/user/authStore";

interface HeaderProps {
  tripName?: string;
  destinations: number;
  totalDays?: number;
  travelers: number;
  hasOnlyOrigin: boolean;
}

const Header: React.FC<HeaderProps> = ({
  tripName = "Trip Overview",
  destinations,
  totalDays,
  travelers,
  hasOnlyOrigin,
}) => {
  const { user, anonymousUser } = useAuthStore();

  return (
    <div className="space-y-2.5 2xl:space-y-3 mt-0.5 flex-none">
      <h1 className="text-xl md:text-2xl 2xl:text-3xl font-semibold text-neutral-900 tracking-tight">
        {anonymousUser ? "Your" : `${user?.first_name}'s`}{" "}
        <span className="text-indigo-600">{tripName}</span>
      </h1>

      <div className="flex flex-wrap items-center gap-2 md:flex-row md:space-x-3 2xl:space-x-3.5">
        <div className="flex flex-row space-x-2 h-[35px] 2xl:h-[38px] px-3.5 2xl:px-3.5 items-center rounded-full bg-neutral-100/90 text-neutral-700">
          <MapPin className="w-4 h-4 2xl:w-[18px] 2xl:h-[18px]" />
          <span className="text-[13px] 2xl:text-[14px] font-light">
            {destinations > 0 ? `${destinations} locations` : "No locations"}
          </span>
        </div>

        {!hasOnlyOrigin && totalDays && (
          <div className="flex flex-row space-x-2 h-[35px] 2xl:h-[38px] px-3.5 2xl:px-3.5 items-center rounded-full bg-neutral-100/90 text-neutral-700">
            <Calendar className="w-4 h-4 2xl:w-[18px] 2xl:h-[18px]" />
            <span className="text-[13px] 2xl:text-[14px] font-light">{totalDays} days</span>
          </div>
        )}

        <div className="flex flex-row space-x-2 h-[35px] 2xl:h-[38px] px-3.5 2xl:px-3.5 items-center rounded-full bg-neutral-100/90 text-neutral-700">
          <Users className="w-4 h-4 2xl:w-[18px] 2xl:h-[18px]" />
          <span className="text-[13px] 2xl:text-[14px] font-light">
            {travelers > 0
              ? travelers === 1
                ? "1 traveler"
                : `${travelers} travelers`
              : "No travelers"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Header;
